/**
 * Labstep
 *
 * @module state/middleware/entity-cursor
 * @desc Middleware to handle cursor-based pagination actions
 */

import { DEFAULT_CURSOR } from 'labstep-web/constants/cursor';
import type { Action } from 'labstep-web/models/action.model';
import * as sfApi from 'labstep-web/services/sf-api.service';
import { getRoute } from 'labstep-web/state/actions/entity';
import snakeCase from 'lodash/snakeCase';

export const entityCursorMiddleware =
  (store: any) => (next: any) => (action: Action) => {
    const state = store.getState();

    if (action.type.startsWith('READ_CURSOR_')) {
      const {
        cursorOptions,
        entityName,
        entitiesName,
        identifier,
        options,
        params,
      }: any = action.meta;

      let cursor = DEFAULT_CURSOR;
      const refresh = cursorOptions?.refresh || cursorOptions?.mount;

      const readingId =
        state.entities?.[entityName]?.readingIds?.[identifier];
      const nextCursor = readingId?.next_cursor;

      if (!refresh && nextCursor) {
        cursor = nextCursor;
      }

      const apiAction = sfApi.get({
        type: `READ_CURSOR_${snakeCase(entityName)}`,
        route: getRoute('get', entityName, true),
        meta: {
          identifier,
          cursor,
          cursorOptions,
          normalize: entitiesName,
        },
        params: { ...params, cursor },
        ...options,
      });

      return next(apiAction);
    }

    return next(action);
  };
